import React, { useEffect, useState } from 'react'
import Header from '../../Layout/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { allapiAction } from '../../../Redux/common/action';
import { Table } from 'antd';
import moment from "moment";
function LevelIncome() {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pagev = searchParams.get("page");
    const searchData = searchParams.get("search");

    const page = pagev == null ? 1 : pagev;
    const search = searchData == null ? "" : searchData;
    const [pages, setPage] = useState(1);
    const order_list = useSelector((state) =>
        state?.allapi?.my_direct_team ? state?.allapi?.my_direct_team : {}
      );
    const listdata = order_list?.docs ? order_list?.docs : [];

    useEffect(() => {
        // if (search) {
        //   dispatch(allapiAction.getSearchOrdervendor({ page: page, key: search }));
        // } else {
          dispatch(allapiAction.getlavelincomeUser({page}));
        // }
        // dispatch(allapiAction.getInvoceDetails());
        return () => {};
      }, [location]);

    const hendlePahegi = (e) => {
        setPage(e);
    
        console.log(location);
    
        navigate("/level-income?page=" + e + "&&search=" + search);
    
        
      };
      const columns = [
        {
          title: "S.No.",
          dataIndex: "sno",
          key: "sno",
          className: "table_first_col",
          render: (value, item, index) => (page - 1) * 10 + index + 1,
        },
        {
          title: "From Id",
          dataIndex: "referId",
          key: "referId",
          className: "table_action_col",
          render: (value, item, index) => {
            return (
              <>
                <span
                  className="cursor-pointer coustomNevc"
                  // onClick={() => navigate(`/user-details/${item?.referId}`)}
                >
                  {item?.userId?.referId}
                </span>
              </>
            );
          },
        },
        // {
        //   title: "User Name",
        //   dataIndex: "fullName",
        //   key: "fullName",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <span
        //           className="cursor-pointer coustomNevc"
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {item?.sp?.fullName}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Number",
        //   dataIndex: "phone",
        //   key: "phone",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <span
        //           className="cursor-pointer coustomNevc"
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {item?.sp?.phone}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        // {
        //   title: "Sponsor Id",
        //   dataIndex: "referBy",
        //   key: "referBy",
        //   className: "table_action_col",
        //   render: (value, item, index) => {
        //     return (
        //       <>
        //         <span
        //           className="cursor-pointer coustomNevc"
        //           // onClick={() => navigate(`/user-details/${item?.referId}`)}
        //         >
        //           {item?.sp?.referBy}
        //         </span>
        //       </>
        //     );
        //   },
        // },
        {
          title: "From",
          dataIndex: "referBy",
          key: "referBy",
          className: "table_action_col",
          render: (value, item, index) => {
            return (
              <>
                <span
                  className="cursor-pointer coustomNevc"
                  // onClick={() => navigate(`/user-details/${item?.referId}`)}
                >
                  {item?.userId?.fullName}
                </span>
              </>
            );
          },
        },
        {
          title: "Level",
          dataIndex: "levelNo",
          key: "levelNo",
        },
        {
          title: "Income",
          dataIndex: "commision",
          key: "commision",
          className: "table_action_col",
          render: (value, item, index) => {
            return (
              <>
                <span
                  className="cursor-pointer coustomNevc"
                  // onClick={() => navigate(`/user-details/${item?.referId}`)}
                >
                  {item?.commision ? item?.commision?.toFixed(4) : 0}
                </span>
              </>
            );
          },
        },
        // {
        //   title: "Income",
        //   dataIndex: "commision",
        //   key: "commision",
        // },
    
        {
          title: "Date",
          dataIndex: "Join Date",
          key: "Join Date",
          // className: "table_action_col",
          render: (value, item, index) => {
            return (
              <>
                {/* <Tooltip title="Contact"> */}
                <span
                  className="cursor-pointer"
                  // onClick={() => navigate(`/bonus-income/contact/${item?.id}`)}
                >
                  {moment(item?.createdAt).format(" DD/MM/YYYY ")}
                </span>
              </>
            );
          },
        },
     
      ];
  return (
    <div>
<Header />
      <div classsName="my">
        <div class="container mt-5 pt-5 mb-5 pb-5">



        <div className="tableResponsive mt-10">
        <Table
          className={"table antd_table"}
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: order_list?.totalDocs ? order_list?.totalDocs : 0,
          }}
        />
      </div>
        </div>

    </div>
    <div style={{ height: "100px" }}></div>
    </div>
  )
}

export default LevelIncome